export default __webpack_public_path__ + "static/media/AVAX.e1f8bcf9.svg";